module.exports = __webpack_public_path__ + "img/1481435668.dc6d1b81.jpg";